export const CohortsFilterLoading = () => {
  return (
    <>
      <div className="flex h-12 animate-pulse items-center gap-2 rounded-2xl border bg-gray-200 p-5">
        <div className="h-5 w-20 rounded-full bg-gray-400" />
        <div className="h-5 w-20 rounded-full bg-gray-400" />
        <div className="h-5 w-20 rounded-full bg-gray-400" />
        <div className="h-5 w-20 rounded-full bg-gray-400" />
      </div>
    </>
  );
};
